import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toastHandler: boolean = false;

  constructor(
    public toastController: ToastController,
  ) { }

  async info(message?) {
    this.resetToast();

    let msg = '';
    msg = message;
    if (!message) {
      msg = 'Olá!';
    }

    const toast = await this.toastController.create({
      color: 'light',
      duration: 1500,
      message: msg,
      position: 'top',
      animated: true,
      cssClass: 'disguisedToast',
      buttons: [
        {
          side: 'end',
          text: 'Ok',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    await toast.present();
  }

  async success(message?) {
    this.resetToast();

    let msg = '';
    msg = message;
    if (!message) {
      msg = 'Salvo com Sucesso!';
    }

    const toast = await this.toastController.create({
      color: 'success',
      duration: 1500,
      message: msg,
      position: 'top',
      animated: true,
      cssClass: 'disguisedToast',
      buttons: [
        {
          side: 'end',
          text: 'Ok',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    await toast.present();
  }

  async danger(message?, customTime?) {
    this.resetToast();

    let msg = '';
    let time = customTime;
    if (!customTime) {
      time = 1500;
    }
    msg = message;
    if (!message) {
      msg = 'Não foi possível realizar esta ação';
    }

    const toast = await this.toastController.create({
      color: 'danger',
      duration: time,
      message: msg,
      position: 'top',
      animated: true,
      cssClass: 'disguisedToast',
      buttons: [
        {
          side: 'end',
          text: 'Ok',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    await toast.present();
  }

  resetToast() {
    if (this.toastHandler == true) {
      this.toastHandler = false;
      this.toastController.dismiss();
    }

    this.toastHandler = true;

  }
}
